<!-- statics client table -->
<div class="fuse-card auto-width mat-card mb-12 p-0">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row"
        fxLayoutAlign.gt-sm="start start" class="dis-block p-10">

        <div *ngIf="isLoading" class="m-auto">
            <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>

        <div class="m-l-5" *ngIf="!isLoading">
            <table class="mat-table contact-tbl">
               <caption></caption>
               <thead>
                   <th></th>
                   <th></th>
                   <th></th>
                   <th></th>
                   <th></th>
               </thead>
                <tbody>
                    <tr *ngFor="let contact of contactData">

                        <td> {{contact.nombre ? contact.nombre : 'N/A'}}</td>
                        <td> {{contact.cargo ? contact.cargo : 'N/A'}} </td>
                        <td class="text-right">
                            <div class="dis-grid">
                                <span *ngIf="contact.telefono">{{contact.telefono}}</span>
                                <span *ngIf="contact.movil">{{contact.movil}}</span>
                                <span *ngIf="!contact.telefono && !contact.movil">N/A</span>
                            </div>
                           
                        </td>
                        <td class="text-right">
                            <mat-icon *ngIf="contact.email"
                                class="mat-icon material-icons mat-icon-no-color f-s-15  notranslate"
                                [matTooltip]="contact.email" role="img"> mail_outline
                            </mat-icon>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="!contactData || (contactData && contactData.length === 0)">
                <p>Sin datos de contacto de la empresa seleccionada.</p>
            </div>
        </div>

    </div>
    <!--/ statics client table -->
</div>